export default __webpack_public_path__ + "static/media/3.755e29fb.png";